import React from 'react';

import { AlertList } from '~components';

/**
 * What the assistant does, stated before any of it is filled in.
 *
 * Its own step-1 field rather than part of the builder below it, so it can sit above the cutover date
 * as well as above the criteria. A provider decides whether this is the right tool, and what they are
 * about to be put through, BEFORE they start answering it - underneath the builder the explanation
 * only ever arrived after the choices it describes had been made.
 *
 * Worded as what the assistant does rather than what happens on Start, for the same reason: the
 * question being answered here is "what is this", not "what will that button do".
 */
const CutoverIntro: React.FC = () => (
  <AlertList
    header="This assistant will:"
    color="info"
    listItems={[
      'Service Types - associate the local service types on each service being replaced with its replacement.',
      'Price Plans - give plans carrying those service types a new revision, priced from the service being replaced.',
      'Budgets - end lines running past the cutover the day before it, and hand the dates they give up to the replacement.',
      'Each step is confirmed and applied on its own, so you can stop after any of them and what is done stands.',
    ]}
  />
);

export default CutoverIntro;
